import { render, staticRenderFns } from "./dataShow.vue?vue&type=template&id=65e95b92&scoped=true"
import script from "./dataShow.vue?vue&type=script&lang=js"
export * from "./dataShow.vue?vue&type=script&lang=js"
import style0 from "./dataShow.vue?vue&type=style&index=0&id=65e95b92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e95b92",
  null
  
)

export default component.exports